import { isEmpty } from 'lodash-es';
import { useEffect, useMemo, useState } from 'react';
import { getJobCloseReasons, IJobCloseReasonDTO } from 'wisestep-api';

import { useUserContext } from '../../../context';

const useCloseJobReasonsSettings = (): IJobCloseReasonDTO => {
  const loggedInUser = useUserContext();
  const defaultSettings: IJobCloseReasonDTO = useMemo(
    () => ({
      id: '',
      reasons: [
        'Role has been filled',
        'Role is no longer necessary',
        'Role requirement has changed',
        'Other reason',
      ],
      createdbyid: loggedInUser?.workspaceUser?.id ?? '',
      createdon: '',
      modifiedbyid: loggedInUser?.workspaceUser?.id ?? '',
      modifiedon: '',
    }),
    [loggedInUser?.workspaceUser?.id]
  );

  const [closeJobSettings, setCloseJobSettings] = useState<IJobCloseReasonDTO>(defaultSettings);

  useEffect(() => {
    (async function () {
      if (closeJobSettings.id === '') {
        const jobCloseReasonsResponse = await getJobCloseReasons();
        if (!isEmpty(jobCloseReasonsResponse.data?.reasons)) {
          if (!jobCloseReasonsResponse.data.reasons.includes('Other reason')) {
            jobCloseReasonsResponse.data.reasons.push('Other reason');
          }
          setCloseJobSettings(jobCloseReasonsResponse.data);
        } else setCloseJobSettings({ ...defaultSettings, id: 'defaultId' });
      }
    })();
  }, [closeJobSettings, defaultSettings]);

  return closeJobSettings;
};

export default useCloseJobReasonsSettings;
